import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import FloorFields from './FloorFields'

export const FloorEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <FloorFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default FloorEdit
